import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http'; 
import { HttpModule } from '@angular/http';
import { tap } from 'rxjs/operators/tap';

const url = "http://api.reptilebin.com/api/SendMail/";
//const url = "http://localhost:53148/api/SendMail";
const httpOptions = {
	headers: new HttpHeaders({
		'Content-Type': 'application/json',
		'Access-Control-Allow-Origin':'*',
		'Access-Control-Allow-Methods': 'HEAD, GET, POST, PUT, PATCH, DELETE',
		'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token'
	})
};

@Injectable()
export class SendMailService {

	constructor(private http: HttpClient) { }
	
	sendMessage(messageContent: any): Observable<any> {
		return this.http.post(url + "/SubmitContactForm",
	  	JSON.stringify(messageContent),
	  { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), responseType: 'text' });

	}

	//async sendTestMessage() {
	  //return this.http.get(url + "/SubmitContactForm",
	  //{ headers: new HttpHeaders({ 'Content-Type': 'application/json' }), responseType: 'text' });
	//}

	sendTestMessage():Observable<string> {
		return this.http.get<string>(url+"/TestMailer", httpOptions).pipe(
			tap(resp => {
				return resp;
		}));
	}
}



// WEBPACK FOOTER //
// ./src/app/services/sendmail.service.ts